import { Injectable } from '@angular/core';
import { Constant } from '../constant/constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { EcryptServiceService } from '../core/auth/EcryptionService/ecrypt-service.service';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
export const TOKEN = 'token'
export const AUTHENTICATED_USER = 'authenticaterUser'
export const USER_ID = 'ID'


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  loginError: any;
  currentPlaform: string;
  userLogin: boolean = false;
  public authenticatedUserSubject = new BehaviorSubject<string>('');
  constructor(private http: HttpClient,
    private ecryptServiceService: EcryptServiceService
  ) {
    this.authenticatedUserSubject.next(this.getAuthenticatedUser());
  }

  updateAuthenticatedUser(username: string) {
    localStorage.setItem(AUTHENTICATED_USER, username);
    document.cookie = `user-name=${username};path=/`;
    this.authenticatedUserSubject.next(username);
  }


  verifyCaptchah(captcha): Observable<Response[]> {
    let url = environment.serverAPI + "/api/verify/captcha";
    return this.http.post<Response[]>(`${url}`, captcha);
  }

  private buildHeaders(includeEnterpriseHeader: boolean = true): HttpHeaders {
    const headerObject: any = {
      'Content-Type': 'application/json'
    };

    if (Constant.DEVICE_TYPE == 'MOBILE') {
      headerObject[Constant.Source_Header] = Constant.source;
    }

    if (includeEnterpriseHeader) {
      const enterpriseToken = localStorage.getItem(Constant.enterPriseKey);
      if (enterpriseToken) {
        headerObject[Constant.enterPriseKey] = enterpriseToken;
      }
    }

    return new HttpHeaders(headerObject);
  }

  private mapMobileLoginResponse(response: any) {
    if (
      response.body == '' ||
      response == undefined ||
      response == null
    ) {
      this.loginError = 'Username or Password is invalid';
      return { error: this.loginError };
    } else if (response.body.status_code == 'AST-102') {
      return response.body;
    } else if (response.body.status_code == 'AST-105') {
      return response.body;
    } else if (response.body?.data?.twoFactorRequired) {
      return response.body;
    } else {
      this.userLogin = true;

      if (response.body?.data?.customer?.firstName) {
        localStorage.setItem(
          AUTHENTICATED_USER,
          response.body.data.customer.firstName
        );
      }

      if (response.body?.data?.userToken) {
        localStorage.setItem(
          Constant.X_XSRF_TOKEN,
          `${response.body.data.userToken}`
        );
      }

      if (response.body?.data?.accessToken) {
        localStorage.setItem(
          Constant.XSRF_TOKEN,
          `${response.body.data.accessToken}`
        );
      }

      if (response.body?.data?.cid) {
        localStorage.setItem(
          Constant.enterPriseKey,
          `${this.ecryptServiceService.encrypt(response.body.data.cid)}`
        );
      }

      return response.body;
    }
  }



  loginFn(username, password, captcha, enterPriseName) {
    let source = Constant.source;
    let payLoad = {
      username: username,
      password: password,
      source: source,
      captcha: captcha
    }

    if (Constant.DEVICE_TYPE != "MOBILE" && enterPriseName == null) {


      let headers = this.buildHeaders(false);

      return this.http.post<any>(`${environment.serverAPI}/api/auth/user/login/new`, payLoad, {
        observe: "response",
        headers: headers
      }).pipe(
        map((response) => this.mapMobileLoginResponse(response))
      );
    }
    else if (Constant.DEVICE_TYPE == "MOBILE" && enterPriseName == null) {


      let headers = this.buildHeaders(false);

      let payLoad = {
        username: username,
        password: password,
        source: source,
        captcha: captcha
      }

      return this.http
        .post<any>(
          `${environment.serverAPI}/api/auth/user/login/new`,
          payLoad,
          {
            observe: "response",
            headers: headers
          }

        )
        .pipe(
          map((response) => {
            return this.mapMobileLoginResponse(response);
          })
        );
    }

    else if (Constant.DEVICE_TYPE != "MOBILE") {

      localStorage.setItem(Constant.enterPriseKey, this.ecryptServiceService.encrypt(enterPriseName))
      let headers = this.buildHeaders();

      return this.http.post(`${environment.serverAPI}/api/auth/user/login`, payLoad, {
        headers: headers
      });
    }

    else {

      localStorage.setItem(Constant.enterPriseKey, this.ecryptServiceService.encrypt(enterPriseName))
      let headers = this.buildHeaders();

      let payLoad = {
        username: username,
        password: password,
        source: source,
        captcha: captcha
      }

      return this.http
        .post<any>(
          `${environment.serverAPI}/api/auth/user/login`,
          payLoad,
          {
            observe: "response",
            headers: headers
          }

        )
        .pipe(
          map((response) => {
            return this.mapMobileLoginResponse(response);
          })
        );
    }


  }



  getAuthenticatedUser() {
    let userName = ''
    if (Constant.DEVICE_TYPE == 'MOBILE') {

      userName = localStorage.getItem(AUTHENTICATED_USER);
    } else {
      userName = this.getCookie("user-name");
    }

    return userName;
  }

  sessionData() {
    return this.http.get(`${environment.serverAPI}/api/auth/sesionData`);
  }

  getAuthenticatedUserId() {
    let userId = this.getCookie("user-id");
    return userId;
  }

  getUserId() {
    let userId = localStorage.getItem("userId")
    return userId;
  }


  /**
    * Check the authentication status
    */
  check(): Observable<boolean> {
    if (Constant.DEVICE_TYPE == "MOBILE") {
      let basicAuthHeaderString = this.getStorageToken(
        Constant.X_XSRF_TOKEN
      );

      if (basicAuthHeaderString != "") {
        return of(true);
      } else {
        return of(false);
      }
    } else {
      // For ADMIN_WEB, cookies are HttpOnly and cannot be read via document.cookie.
      // We must ask the backend if the session is valid.
      return this.http.get<any>(`${environment.serverAPI}/api/auth/status`, { withCredentials: true }).pipe(
        map(res => !!res.authenticated),
        catchError(() => of(false))
      );
    }
  }


  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  url4 = environment.serverAPI + "/api/auth";

  getStorageToken(i: any) {
    let token = "";
    if (Constant.DEVICE_TYPE == "MOBILE") {
      token = localStorage.getItem(i);
      if (token == null) {
        token = "";
      }
    } else {
      token = this.getCookie(i);
    }
    return token;
  }

  // Load the refresh token from storage
  // then attach it as the header for one specific API call
  getNewAccessToken() {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      [Constant.X_XSRF_TOKEN]: this.getStorageToken(Constant.X_XSRF_TOKEN),  // encrypted UUID
      [Constant.XSRF_TOKEN]: this.getStorageToken(Constant.XSRF_TOKEN),    // encrypted accessToken
      [Constant.DEVICE]: Constant.DEVICE_TYPE,                          // deviceType header
    });
    return this.http.get(`${this.url4}/refresh/token`, { headers });
  }
  currentAccessToken = null;

  storeAccessToken(i) {
    let tokenValue = typeof i === 'string' ? i : JSON.stringify(i);
    localStorage.setItem(Constant.XSRF_TOKEN, tokenValue);
    return true;
  }

  socialLogin(username, token) {

    let source = Constant.source;
    let payLoad = {
      username: username,
      token: token,
      source: source
    }

    if (Constant.DEVICE_TYPE != "MOBILE") {


      let headers = this.buildHeaders(false);

      return this.http.post<any>(`${environment.serverAPI}/api/auth/user/login/social/new`, payLoad, {
        observe: "response",
        headers: headers
      }).pipe(
        map((response) => this.mapMobileLoginResponse(response))
      );
    }
    else if (Constant.DEVICE_TYPE == "MOBILE") {


      let headers = this.buildHeaders(false);



      return this.http
        .post<any>(
          `${environment.serverAPI}/api/auth/user/login/social/new`,
          payLoad,
          {
            observe: "response",
            headers: headers
          }

        )
        .pipe(
          map((response) => {
            return this.mapMobileLoginResponse(response);
          })
        );
    }




  }

  verifyTwoFactorLogin(tempToken: string, code: string) {
    const payload = {
      tempToken: tempToken,
      code: code
    };
    // 2FA login verification must not rely on a possibly stale enterprise header.
    // The backend already resolves tenant and username from the temporary login token.
    const headers = this.buildHeaders(false);

    if (Constant.DEVICE_TYPE != 'MOBILE') {
      return this.http.post(`${environment.serverAPI}/api/auth/user/login/verify-2fa`, payload, {
        headers: headers
      });
    }

    return this.http
      .post<any>(`${environment.serverAPI}/api/auth/user/login/verify-2fa`, payload, {
        observe: 'response',
        headers: headers
      })
      .pipe(
        map((response) => {
          return this.mapMobileLoginResponse(response);
        })
      );
  }

  setupTwoFactor() {
    return this.http.post(`${environment.serverAPI}/api/auth/user/2fa/setup`, {}, {
      headers: this.buildHeaders()
    });
  }

  confirmTwoFactor(code: string) {
    return this.http.post(`${environment.serverAPI}/api/auth/user/2fa/confirm`, { code: code }, {
      headers: this.buildHeaders()
    });
  }

  disableTwoFactor(payload: { password?: string; code?: string }) {
    return this.http.post(`${environment.serverAPI}/api/auth/user/2fa/disable`, payload, {
      headers: this.buildHeaders()
    });
  }

  getTwoFactorStatus() {
    return this.http.get(`${environment.serverAPI}/api/auth/user/2fa/status`, {
      headers: this.buildHeaders()
    });
  }

  clearSessionData(): void {
    // Remove only authentication-related keys.
    // Never call localStorage.clear() — it removes unrelated data
    // like FCM push tokens, offline cache, and app preferences.
    const authKeys = [
      Constant.XSRF_TOKEN,
      Constant.X_XSRF_TOKEN,
      Constant.enterPriseKey,
      'access_token_expires_at',
      'userId',
      AUTHENTICATED_USER,
    ];
    authKeys.forEach(key => localStorage.removeItem(key));
    this.authenticatedUserSubject.next('');
  }

  /** Returns the stored access-token expiry epoch (ms) for proactive refresh checks, or null. */
  getStoredAccessTokenExpiry(): number | null {
    const val = localStorage.getItem('access_token_expires_at');
    if (!val) return null;
    const n = Number(val);
    return Number.isFinite(n) ? n : null;
  }

  /** Persists the access-token expiry epoch (ms) for proactive refresh checks. */
  setStoredAccessTokenExpiry(epochMs: number): void {
    if (Number.isFinite(epochMs) && epochMs > 0) {
      localStorage.setItem('access_token_expires_at', String(epochMs));
    }
  }


  logout(): Observable<Object> {
    let source = Constant.source;
    this.clearSessionData();
    return this.http.get(`${environment.serverAPI}/api/auth/user/logout/${source}`);
  }


}
export class AuthenticationBean {
  constructor(public message: string) { }
}
